// Image filters read by the landing carousels. src/utils/home.ts trims the data sent to
// them to these filters, so both sides change together from here.
export const VILLA_TYPE_FILTER = '1280w_webp';
export const EXPERIENCE_FILTER = '1920w_webp';
